import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import ProgressSpinner
  from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import {
  publicContextPropType,
  withPublicContext,
} from '../../../contexts/PublicContext/PublicContext';
import envConfig from '../../../envConfig';
import RaApiQuoteMapperV1 from '../../../classes/mappers/quotes/RaApiQuoteMapperV1';
import { LoadingState } from '../../../utility/types/LoadingState';
import NotAuthenticatedQuoteScreen
  from '../../quotes/QuoteDetailsPage/NotAuthenticatedQuoteScreen/NotAuthenticatedQuoteScreen';
import {
  getResourceIdFromURLParam,
  generateResourceURLFromParam,
} from '../../../utility/orderAndQuoteUtil';

class PublicQuotePage extends React.Component {
  constructor(props) {
    super(props);
    const { id } = props.match.params;
    this.state = {
      loadingState: LoadingState.LOADING,
      quoteDetails: { quoteNumber: `QUO-${getResourceIdFromURLParam(id)}` },
    };
  }

  async componentDidMount() {
    const { publicContext, history, match } = this.props;
    const { id } = match.params;
    const hasPermission = await publicContext.hasAdnSession();
    if (!hasPermission) {
      await this.getData();
    } else {
      history.push(`/s/quotes/details/QUO-${generateResourceURLFromParam(id)}`);
      window.location.reload();
    }
  }

  async getData() {
    const { match } = this.props;
    const { id } = match.params;
    this.setState({ loadingState: LoadingState.LOADING });
    try {
      const quoteResponse = await axios.get(
        `${envConfig.apiUrl}/api/v1/quotes/public/${generateResourceURLFromParam(id)}`,
      );
      const quote = RaApiQuoteMapperV1
        .mapJsonToQuote(quoteResponse.data.data.quoteDetails);
      this.setState({
        quoteDetails: quote,
        loadingState: LoadingState.COMPLETE,
      });
    } catch (e) {
      this.setState({ loadingState: LoadingState.ERROR });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  renderHeader() {
    return (
      <>
        <div className="row">
          <div className="col"><h3>Thank you for requesting a quote for Room Alert products.</h3></div>
          {' '}
        </div>
        <div className="row mb-4">
          <div className="col">
            Basic information about your quote is listed below. For additional
            details,
            {' '}
            <b>please log in to Room Alert Account</b>
            .
          </div>
          {' '}
        </div>
      </>
    );
  }

  render() {
    const {
      loadingState, quoteDetails,
    } = this.state;

    switch (loadingState) {
      case LoadingState.COMPLETE:
        return (
          <div>
            {this.renderHeader()}
            <NotAuthenticatedQuoteScreen quote={quoteDetails} loadError={false} />
          </div>
        );
      case LoadingState.ERROR:
        return (
          <>
            {this.renderHeader()}
            <NotAuthenticatedQuoteScreen quote={quoteDetails} loadError />
          </>
        );
      case LoadingState.LOADING:
      default:
        return (
          <>
            {this.renderHeader()}
            <div className="row d-flex justify-content-center mt-5">
              <div><ProgressSpinner progressText="Loading..." /></div>
            </div>
          </>
        );
    }
  }
}

PublicQuotePage.propTypes = {
  publicContext: publicContextPropType.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) })
    .isRequired,
};

export { PublicQuotePage };
export default withPublicContext(withRouter(PublicQuotePage));
